'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('../styles');

var _styles2 = _interopRequireDefault(_styles);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _aphrodite = require('aphrodite');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = _aphrodite.StyleSheet.create({
	iconTopperIcon: {
		display: 'table-cell',
		verticalAlign: 'middle',
		paddingTop: '6px',
		':before': {
			fontSize: '30px'
		}
	}
});

var IconTopper = function IconTopper(_ref) {
	var flowType = _ref.flowType;

	/**
  * Gets the correct classes for the icon font based on flowType
  * @param flowType {String} 'send', 'request', or 'buy'
  * @return {String} the class string to be applied to className
  */
	var getIconFont = function getIconFont() {
		if (flowType === 'buy') {
			return 'icon icon-medium icon-register';
		}
		return 'icon icon-medium icon-' + flowType + '-money';
	};

	return _react2.default.createElement(
		'div',
		{ style: _styles2.default.iconTopperWrapper },
		_react2.default.createElement('span', { className: (0, _classnames2.default)((0, _aphrodite.css)(styles.iconTopperIcon), getIconFont()), style: styles.iconTopperIcon })
	);
};

IconTopper.propTypes = {
	flowType: _react2.default.PropTypes.oneOf(['send', 'request', 'buy'])
};

exports.default = IconTopper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/IconTopper.js
// module id = 403
// module chunks = 6